<template>
  <div ref="rootRef" class="collage-carousel">
    <div class="rasgado rasgado-top"></div>
    <br /><br />

    <!-- FONDO ROSA -->
    <div ref="bgRef" class="bg-rosa"></div>

    <!-- 🌸 ORNAMENTOS EN ORILLAS -->
    <img src="@/assets/monio.png" class="flor flor-lt render-gpu" alt="Ornamento" />
    <img src="@/assets/monio.png" class="flor flor-lb render-gpu" alt="Ornamento" />
    <img src="@/assets/monio.png" class="flor flor-rt render-gpu" alt="Ornamento" />
    <img src="@/assets/monio.png" class="flor flor-rb render-gpu" alt="Ornamento" />

    <!-- CONTENEDOR DE IMÁGENES EDITORIALES -->
    <div class="collage-grid">
      <div
        v-for="(imgSrc, index) in imagesList"
        :key="index"
        ref="imageContainersRef"
        class="collage-item render-gpu"
        @click="openModal(imgSrc)"
      >
        <img
          class="collage-video"
          :src="imgSrc"
          :alt="'Imagen editorial ' + (index + 1)"
        />
      </div>
    </div>

    <!-- MODAL DE IMAGEN AMPLIADA -->
    <div
      v-if="isImageEnlarged"
      class="image-modal"
      @click="closeModal"
    >
      <img
        class="enlarged-video"
        :src="selectedImage"
        alt="Imagen ampliada"
      />
    </div>

    <div class="rasgado rasgado-inferior"></div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'CollageAnimadoMagico',
  setup() {
    const rootRef = ref(null)
    const bgRef = ref(null)
    const imageContainersRef = ref([])

    const imagesList = ref([
      require('@/assets/DSC_5215_11zon.webp'),
      require('@/assets/DSC_5416_11zon.webp'),
      require('@/assets/DSC_5541_11zon.webp'),
      require('@/assets/DSC_5600_11zon.webp'),
      require('@/assets/DSC_5632_11zon.webp')
    ])

    const isImageEnlarged = ref(false)
    const selectedImage = ref('')

    let observer = null

    const openModal = (imgSrc) => {
      selectedImage.value = imgSrc
      isImageEnlarged.value = true
    }

    const closeModal = () => {
      isImageEnlarged.value = false
      selectedImage.value = ''
    }

    onMounted(async () => {
      await nextTick()

      gsap.config({ force3D: true })

      const flores = rootRef.value.querySelectorAll('.flor')

      // Estados iniciales
      gsap.set(bgRef.value, { autoAlpha: 0 })
      gsap.set(flores, { autoAlpha: 0, scale: 0.9, y: 8 })
      gsap.set(imageContainersRef.value, { autoAlpha: 0, scale: 0.96, y: 15 })

      // Observador de pantalla
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return

          const tl = gsap.timeline({ defaults: { ease: 'power2.out', force3D: true } })

          // 1. Revelado de fondo
          tl.to(bgRef.value, { autoAlpha: 1, duration: 0.3 })
            // 2. Revelado en cascada de las imágenes
            .to(imageContainersRef.value, {
              autoAlpha: 1,
              scale: 1,
              y: 0,
              duration: 0.5,
              stagger: 0.12
            }, '-=0.2')
            // 3. Entrada de ornamentos
            .to(flores, {
              autoAlpha: 0.95,
              scale: 1,
              y: 0,
              duration: 0.5,
              stagger: 0.05
            }, '-=0.4')

          if (rootRef.value) observer.unobserve(rootRef.value)
        })
      }, { threshold: 0.05, rootMargin: '0px 0px -20px 0px' })

      if (rootRef.value) observer.observe(rootRef.value)
    })

    onUnmounted(() => {
      if (observer) observer.disconnect()
    })

    return {
      rootRef,
      bgRef,
      imageContainersRef,
      imagesList,
      isImageEnlarged,
      selectedImage,
      openModal,
      closeModal
    }
  }
}
</script>

<style scoped>
.collage-carousel {
  position: relative;
  width: 100%;
  min-height: 60vh;
  margin-bottom: 20px;
  overflow: visible;
}

/* FONDO ROSA */
.bg-rosa {
  position: absolute;
  inset: 0;
  background: #f0c9d3;
  z-index: 0;
  opacity: 0;
}

/* 🌸 FLORES */
.flor {
  position: absolute;
  width: 150px;
  max-width: 42vw;
  opacity: 0;
  pointer-events: none;
  z-index: 3;
}

.flor-lt { top: -2vh; left: -40px; }
.flor-lb { bottom: 5vh; left: -50px; }
.flor-rt { top: -2vh; right: -40px; }
.flor-rb { bottom: 5vh; right: -50px; }

/* GRID */
.collage-grid {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  padding-top: 4vh;
  padding-bottom: 4vh;
}

/* ITEM */
.collage-item {
  grid-column: span 12;
  opacity: 0;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 4vh;
}

/* ESTILOS PARA LAS IMÁGENES */
.collage-video {
  width: 90%;
  max-width: 480px;
  height: auto;
  display: block;
  border-radius: 14px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.12);
  object-fit: cover;
  pointer-events: auto;
  transition: transform 0.3s ease;
}

.collage-video:hover {
  transform: scale(1.02);
}

/* MODAL AMPLIADO */
.image-modal {
  position: fixed;
  inset: 0;
  background: rgba(10, 10, 10, 0.92);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.enlarged-video {
  max-width: 92%;
  max-height: 85vh;
  border-radius: 12px;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.6);
  object-fit: contain;
}

/* RASGADOS */
.rasgado {
  position: absolute;
  left: 0;
  width: 100%;
  height: 50px;
  pointer-events: none;
  z-index: 1;
}

.rasgado-top {
  top: 0;
  background: #ffffff;
  clip-path: polygon(0% 70%, 18% 55%, 38% 78%, 58% 52%, 78% 75%, 100% 60%, 100% 0%, 0% 0%);
}

.rasgado-inferior {
  bottom: 0;
  background: #f0c9d3;
  clip-path: polygon(
    0% 80%,
    25% 60%,
    50% 85%,
    75% 55%,
    100% 75%,
    100% 0%,
    0% 0%
  );
}

/* Aceleración por Hardware Estricta */
.render-gpu {
  will-change: transform, opacity;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
}
</style>